<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'configurations.title'" [backRoute]="serviceType === ServiceType.CLOUD ? '/software' : undefined"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <div class="row">
      <app-datatable
        [dataSource]="source"
        [columns]="columns"
        [iconActions]="iconActions"
        [identifier]="'configurations'"
        (newEvent)="createNew()"
      >
        <app-empty-table
          [emptyText]="'configurations.empty_text' | translate"
          [buttonText]="'configurations.create_new' | translate"
          (btnClick)="createNew()"
          [icon]="'manufacturing'"
        >
        </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>

      @if (isAdmin()) {
        <app-model-modal #EditOrgModal (saveEvent)="onSave()">
          <app-configuration-org-form #form (closeEvent)="onModalClose()" (loadingEvent)="onLoading($event.valueOf())"></app-configuration-org-form>
        </app-model-modal>
      }
    </div>
  </div>
</div>
